import * as Sentry from '@sentry/browser'; // eslint-disable-line import/no-namespace

const setUser = userId => {
  Sentry.configureScope(scope => {
    scope.setUser({id: userId});
  });
};

export default setUser;
